<template>
  <div id="login-layer">
    <div class="top-logo">
      <img :src="logoDarkSrc" class="login-logo" alt="" ondragstart="return false" />
      <div>电子合同服务平台</div>
    </div>
    <div class="login-content">
      <div class="login-main-layer">
        <div class="login-imgs">
          <div class="code-imgs clearfix"></div>
          <img src="../assets/images/login/login-bg-text.png" class="login-text-img" alt="" />
          <img src="../assets/images/login/stripe.png" class="login-stripe" alt="" ondragstart="return false" />
        </div>
        <div class="login-main-box">
          <div class="welcome">
            {{ status == "login" ? "欢迎使用电子合同服务平台" : "注册账号" }}
          </div>
          <div v-show="status == 'login'">
            <el-tabs v-model="active" @tab-click="handleChangeTab" :class="{ 'captcha-wrap': method == 'pwd' }">
              <el-tab-pane label="个人账户" name="person"></el-tab-pane>
              <el-tab-pane label="企业账户" name="company"></el-tab-pane>
            </el-tabs>
            <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" @keyup.enter.native="logIn">
              <el-form-item label="" prop="account" v-if="method == 'sms'">
                <el-input placeholder="请输入手机号" maxlength="11" v-model="loginForm.account">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="account" v-else>
                <el-input :placeholder="
                  active == 'person' ? '请输入个人账号' : '请输入企业账号'
                " maxlength="25" v-model="loginForm.account">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="password" v-if="method == 'pwd'">
                <el-input placeholder="请输入登录密码" maxlength="14" v-model="loginForm.password" type="password">
                </el-input>
              </el-form-item>
              <el-form-item prop="vcode" v-else>
                <el-input class="vcode-ipt" placeholder="输入验证码" maxlength="6" v-model="loginForm.vcode"></el-input>
                <div class="code-btn">
                  <el-button type="primary" plain :disabled="!sendAuthCode" @click="getMsgAuthCode"
                    v-show="sendAuthCode">获取验证码
                  </el-button>
                  <el-button type="primary" plain v-show="!sendAuthCode">{{ auth_time }}秒</el-button>
                </div>
              </el-form-item>
              <el-form-item prop="imgCode" v-if="method == 'pwd'">
                <el-input class="captcha-ipt" placeholder="输入验证码" maxlength="4" v-model="loginForm.imgCode"></el-input>
                <div class="code-btn">
                  <img :src="captchaImg" @click="handleGetCaptchaImage" class="captcha-img" alt=""
                    ondragstart="return false" />
                </div>
              </el-form-item>

              <div class="flex tip">
                <span>
                  <span>没有账号？<span class="link" @click="switchLoginRegister('register')"
                      style="cursor: pointer">立即注册</span></span>
                </span>
                <span>
                  <!-- <router-link class="link" to="/register">忘记密码？</router-link> -->
                </span>
              </div>
              <div class="flex tip login-agreement">
                <el-checkbox v-model="loginPrivacyChecked">
                  我已阅读并同意<a :href="privacyAgreementUrl" target="_blank" class="link">《服务协议》</a>、<a
                    :href="userAgreementUrl" target="_blank" class="link">《用户使用协议》</a>、
                </el-checkbox>
                <div style="padding-left: 18px">
                  <a :href="privacyPolicyUrl" target="_blank" class="link">《用户隐私政策》</a>
                </div>
                <div v-show="showLoginPrivacyWarn" role="tooltip" class="el-popover el-popper el-popover--plain"
                  tabindex="0" style="transform-origin: center bottom" x-placement="top-start">
                  请先阅读并勾选《服务协议》、《用户使用协议》和《隐私政策》。
                  <div x-arrow="" class="popper__arrow" style="left: 32.5px"></div>
                </div>
              </div>
              <div class="bottom">
                <el-button type="primary" class="bottom-btn" @click="logIn">登 录</el-button>
                <el-button type="text" class="txt-btn" @click="switchSmsLogin">{{ method == "pwd" ? "短信登录" : "账号登录" }}
                </el-button>
              </div>
            </el-form>
          </div>
          <div v-show="status == 'register' && !registered" class="register-form-wrap">
            <el-form class="register-form" :model="registerForm" :rules="registerFormRules" ref="registerForm"
              @keyup.enter.native="submitRegister($event)">
              <!-- <div class="title">注册</div> -->
              <el-form-item label="请先选择账号类型" prop="userType" style="margin-bottom: 0">
                <el-radio-group v-model="registerForm.userType">
                  <el-radio label="person">个人</el-radio>
                  <el-radio label="company">企业</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="" prop="address">
                <el-input placeholder="请输入手机号" maxlength="11" v-model="registerForm.address">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="vcode">
                <el-input class="vcode-ipt" placeholder="输入验证码" maxlength="6" v-model="registerForm.vcode"></el-input>
                <div class="code-btn">
                  <el-button type="primary" plain :disabled="!sendAuthCode" @click="getMsgAuthCode('register')"
                    v-show="sendAuthCode">获取验证码
                  </el-button>
                  <el-button type="primary" plain v-show="!sendAuthCode">{{ auth_time }}秒</el-button>
                </div>
              </el-form-item>
              <el-form-item label="" prop="password">
                <el-input placeholder="请输入登录密码" maxlength="14" v-model="registerForm.password" type="password">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="pin">
                <el-input placeholder="请输入签署密码" maxlength="6" v-model="registerForm.pin" type="pin">
                </el-input>
              </el-form-item>
              <div class="flex tip">
                <el-checkbox v-model="privacyChecked">
                  我已阅读并同意<a :href="privacyAgreementUrl" target="_blank" class="link">《服务协议》</a>、<a
                    :href="userAgreementUrl" target="_blank" class="link">《用户使用协议》</a>、
                </el-checkbox>
                <div style="padding-left: 18px">
                  <a :href="privacyPolicyUrl" target="_blank" class="link">《用户隐私政策》</a>
                </div>
                <div v-show="showPrivacyWarn" role="tooltip" class="el-popover el-popper el-popover--plain" tabindex="0"
                  style="transform-origin: center bottom" x-placement="top-start">
                  请先阅读并勾选《服务协议》、《用户使用协议》和《隐私政策》。
                  <div x-arrow="" class="popper__arrow" style="left: 32.5px"></div>
                </div>
              </div>
              <div class="bottom" :style="{ bottom: status == 'register' ? '30px' : '56px' }">
                <el-button type="primary" :loading="loading" class="bottom-btn" @click="submitRegister($event)">提 交
                </el-button>
                <el-button type="text" class="txt-btn" @click="switchLoginRegister('login')">已有账号登录</el-button>
              </div>
            </el-form>
          </div>
          <div class="register-success" v-show="registered">
            <div class="title">注册成功</div>
            <img src="../assets/images/feedback-success.png" alt="" />
            <div class="tip">恭喜您注册成功，请重新登录</div>
            <div class="jump">
              <span class="blue"></span>
              <span>{{ countdown }}秒后跳转至登录页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <e-footer></e-footer>
  </div>
</template>
<script>
import eFooter from "@/components/eFooter";
import { getCaptchaImage, getsmsCodeApi } from "@/api/common";
import { registerApi } from "@/api/register";
import { setToken } from "@/utils/auth";
import { JITHTTPCLIENT } from "../utils/JITHTTPCLIENT";
import Cookies from "js-cookie";
export default {
  components: {
    eFooter,
  },
  data() {
    // 校验手机号格式
    var checkPhone = (rule, value, callback) => {
      var phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error("请输入正确手机号！"));
      } else {
        callback();
      }
    };

    // 密码正则
    var passwordReg = (rule, value, callback) => {
      var pReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,14}$/;
      if (!pReg.test(value)) {
        callback(new Error("密码格式不正确！数字字母，8-14位！"));
      } else {
        callback();
      }
    };

    return {
      logoDarkSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/logo-dark.png",
      privacyAgreementUrl:
        ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
        "common/agreement/service-agreement.html",
      userAgreementUrl:
        ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
        "common/agreement/user-agreement.html",
      privacyPolicyUrl:
        ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) +
        "common/agreement/privacy-policy.html",
      active: "person",
      method: "sms",
      status: "login",
      privacyChecked: false,
      loginPrivacyChecked: false,
      showLoginPrivacyWarn: false,
      showPrivacyWarn: false,
      registered: false,
      captchaImg: "",
      captchaImgUUid: "",

      showWechatCode: false,
      loading: false,
      stitle: "",
      itemActive: "account",
      countdown: 3,

      loginForm: {
        account: "",
      },
      registerForm: {
        userType: "person",
        vcode: "",
        address: "",
        password: "",
      },
      registerFormRules: {
        address: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        vcode: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        // pin: [
        //   {
        //     required: true,
        //     message: "请输入",
        //     trigger: "change",
        //   },
        // ],
      },
      loginFormRules: {
        account: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        vcode: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        imgCode: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
      },
      codeImg: "",
      sendAuthCode: true,
      auth_time: 1,
      auth_timetimer: null,
      imgCodeUUid: "",
      sign: "",
      random: "",
      randomId: "",
      dialogVisible: false,
      accountList: [],
    };
  },
  created() { },
  mounted() { },
  methods: {
    getMsgAuthCode(type) {
      let form = "loginForm";
      let field = "account";
      if (type == "register") {
        form = "registerForm";
        field = "address";
      }
      this.$refs[form].validateField(field, (error) => {
        if (!error) {
          getsmsCodeApi({
            address: this[form][field],
            bizType: type == "register" ? type : "login",
          }).then((res) => {
            console.log(res);
            if (res.code != 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
            } else {
              this.$message({
                message: "短信发送成功",
                type: "success",
              });
              // 倒计时
              this.sendAuthCode = false;
              this.auth_time = 60;
              let auth_timetimer = setInterval(() => {
                this.auth_time--;
                if (this.auth_time <= 0) {
                  this.sendAuthCode = true;
                  clearInterval(auth_timetimer);
                }
              }, 1000);
            }
          });
        }
      });
    },
    switchSmsLogin() {
      this.resetForm("login", true);
      if (this.method == "sms") {
        this.method = "pwd";
        this.handleGetCaptchaImage();
        return;
      }
      if (this.method == "pwd") {
        this.method = "sms";
      }
    },
    switchLoginRegister(option) {
      this.status = option;
      this.sendAuthCode = true;
      this.auth_time = 60;
      clearInterval(this.auth_timetimer);
      this.resetForm(option);
    },
    handleChangeTab() { },
    submitRegister(e) {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          if (!this.privacyChecked) {
            let _this = this;
            this.showPrivacyWarn = true;
            e.preventDefault();
            e.stopPropagation();
            function handler() {
              _this.showPrivacyWarn = false;
              document.documentElement.removeEventListener("click", handler);
            }
            document.documentElement.addEventListener("click", handler);
            return;
          }
          this.loading = true;
          let params = {
            address: this.registerForm.address,
            vcode: this.registerForm.vcode,
            password: this.registerForm.password,
            userType: this.registerForm.userType,
            pin: this.registerForm.pin,
          };
          if (Cookies.get("inviteCode")) {
            params.userInviteCode = Cookies.get("inviteCode");
          }

          registerApi(params).then((res) => {
            if (res.code != 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
              this.loading = false;
              this.registered = false;
            } else {
              this.$message({
                message: "注册成功",
                type: "success",
              });
              this.loading = false;
              this.registered = true;
              let timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                  clearInterval(timer);
                  this.resetForm("register");
                  this.switchLoginRegister("login");
                  this.countdown = 3;
                  this.registered = false;
                }
              }, 1000);
            }
          });
        } else {
          this.loading = false;
          console.log("error submit!");
          return false;
        }
      });
    },
    resetForm(type, noChangeFlag) {
      if (type == "login") {
        this.loginForm = {
          account: "",
        };
        this.$refs["loginForm"].resetFields();
      } else {
        this.privacyChecked = false;
        this.registerForm = {
          userType: this.active,
          vcode: "",
          address: "",
          password: "",
        };
        this.$refs["registerForm"].resetFields();
      }
      !noChangeFlag && (this.active = this.registerForm.userType);
    },
    logIn(e) {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!this.loginPrivacyChecked) {
            let _this = this;
            this.showLoginPrivacyWarn = true;
            e.preventDefault();
            e.stopPropagation();
            function handler() {
              _this.showLoginPrivacyWarn = false;
              document.documentElement.removeEventListener("click", handler);
            }
            document.documentElement.addEventListener("click", handler);
            return;
          }
          this.loading = true;
          const user = {
            userType: this.active,
          };
          if (this.method == "pwd") {
            user.password = this.loginForm.password;
            user.account = this.loginForm.account;
            user.imgUuid = this.captchaImgUUid;
            user.imgCode = this.loginForm.imgCode;
          } else {
            user.address = this.loginForm.account;
            user.vcode = this.loginForm.vcode;
          }
          const method = this.method === "sms" ? "vcodeLogin" : "accountLogin";
          this.$store
            .dispatch(method, user)
            .then(() => {
              this.loading = false;
              this.$router.push({
                path: "/",
              });
              this.$store.commit("SET_USER_CONTRSCT_INFO", {});
              this.$store.commit("SET_COMPSNYL_LIST", {});
              this.$store.commit("SET_CURRENT_SPACE", {});
            })
            .catch((message) => {
              this.$message({
                showClose: true,
                message: message,
                type: "warning",
              });
              this.handleGetCaptchaImage();
              this.loading = false;
            });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },

    getCookie() {
      const username = Cookies.get("username");
      let password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      // 保存cookie里面的加密后的密码
      this.cookiePass = password === undefined ? "" : password;
      password =
        password === undefined ? this.accountRuleForm.password : password;
      this.accountRuleForm = {
        accountphone:
          username === undefined ? this.accountRuleForm.accountphone : username,
        accountpassword: password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        accountcode: "",
      };
    },
    handleGetCaptchaImage() {
      getCaptchaImage().then((res) => {
        this.captchaImg = res.data.img;
        this.captchaImgUUid = res.data.uuid;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top-logo {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
  padding: 34px 52px;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  color: #292d40;

  img {
    display: block;
    width: 111px;
    height: auto;
    margin-right: 19px;
  }
}

.login-content {
  width: 100%;
  height: 100vh;
  background: url("../assets/images/login/login-bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;

  .login-main-layer {
    // width: 80%;
    // height: calc(100vh - 71px);
    // margin: 0 auto;
    // position: relative;
    max-width: 1143px;
    height: 555px;
    background: #ffffff;
    box-shadow: 0px 3px 32px 0px rgba(50, 150, 250, 0.13);
    border-radius: 8px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    overflow: hidden;

    .login-imgs {
      position: absolute;
      left: 0;
      top: 0;
      width: calc(100% - 446px);
      height: 555px;
      background: linear-gradient(0deg, #2f45cd 0%, #68adfc 100%);

      .login-text-img {
        display: block;
        width: 400px;
        height: auto;
        margin: 160px auto 0;
      }

      .login-stripe {
        display: block;
        width: 632px;
        height: auto;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }

    .login-main-box {
      width: 446px;
      height: 100%;
      padding: 60px 55px 57px;
      background: #ffffff;
      position: absolute;
      right: 0;
      /* top: 198px; */
      top: 0;

      .welcome {
        font-size: 20px;
        font-weight: 400;
        color: #292d40;
        text-align: center;
        margin-bottom: 50px;
      }

      // & > div {
      // 	height: 100%;
      // }
      .el-tabs {
        &.captcha-wrap /deep/ .el-tabs__header {
          padding-bottom: 11px;
        }

        /deep/ .el-tabs__header {
          padding-bottom: 23px;

          .el-tabs__nav-wrap::after {
            content: "";
            display: none;
          }

          .el-tabs__nav {
            width: 100%;
            float: unset;
            display: flex;
            justify-content: space-around;
          }

          .el-tabs__item {
            width: 50%;
            text-align: center;
            padding: 0;
          }

          .el-tabs__active-bar {
            width: 50px !important;
            margin-left: calc(25% - 25px);
          }
        }
      }

      .login-main-item {
        width: 400px;
      }

      .el-form {
        width: 100%;

        .el-form-item {
          margin-bottom: 18px;
          margin-right: 0;

          /deep/ .el-form-item__content {
            line-height: 40px;
          }
        }

        /deep/ .el-form-item__error {
          padding-top: 2px;
        }
      }

      .tip {
        font-size: 13px;
        margin-top: -4px;
        position: relative;

        .link {
          color: #3296fa;
        }
      }

      .vcode-ipt {
        width: calc(100% - 100px);
      }

      .captcha-ipt {
        width: calc(100% - 110px);
      }

      .code-btn {
        .el-button {
          background: #ffffff;
          width: 90px;
          height: 40px;
          border: 1px solid #3296fa;
          color: #3296fa;
          border-radius: 3px;
          padding: 0;

          /deep/ span {
            font-size: 13px;
            font-weight: 400;
          }
        }

        img {
          display: block;
          cursor: pointer;
        }
      }

      .login-agreement {
        position: absolute;
        // width: 100%;
        left: 0;
        bottom: 110px;
        margin: 0 55px;
      }

      .el-popover {
        position: absolute;
        left: 0;
        top: -83px;
        transition: opacity 0.3s ease;
      }

      .bottom {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 16px;
        padding: 0 55px;
        height: 80px;

        .bottom-btn {
          width: 100%;
          // position: absolute;
          // left: 0;
          // bottom: 0;
        }

        .txt-btn {
          margin: 0 auto;
          display: block;
          padding: 12px 20px;
        }
      }

      .register-form-wrap {
        margin-top: -15px;
      }

      .register-form {
        .title {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 12px;
        }

        /deep/ .el-form-item__label {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          width: 192px;
          height: 45px;
          line-height: 45px;
          text-align: left;
        }

        /deep/ .el-checkbox__label {
          font-size: 13px;
        }

        .tip {
          position: relative;

          .el-popover {
            position: absolute;
            left: 0;
            top: -83px;
            transition: opacity 0.3s ease;
          }
        }

        /deep/ .el-radio__inner {
          display: inline-block;
          position: relative;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          z-index: 1;
          transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
            background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);

          &::after {
            box-sizing: content-box;
            content: "";
            border: 1px solid #ffffff;
            border-radius: 0;
            background-color: unset;
            border-left: 0;
            border-top: 0;
            height: 7px;
            left: 4px;
            position: absolute;
            top: 1px;
            transform: rotate(45deg) scaleY(0);
            width: 3px;
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
          }
        }

        /deep/ .el-radio__input.is-checked .el-radio__inner {
          border-color: inherit;
        }

        /deep/ .el-radio__input.is-checked .el-radio__inner::after {
          transform: rotate(45deg) scaleY(.8);

        }
      }

      .register-success {
        .title {
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          text-align: center;
        }

        img {
          width: 153px;
          height: auto;
          display: block;
          margin: 73px auto 57px;
        }

        .tip {
          font-size: 13px;
          font-weight: 400;
          color: #333333;
          text-align: center;
          margin-bottom: 10px;
        }

        .jump {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          text-align: center;
        }

        .blue {
          color: #3296fa;
        }
      }
    }
  }
}

// @media screen and (min-width: 1200px) and (max-width: 1499px) {
// 	.login-main-layer {
// 		width: 70%;
// 	}
// }
// @media screen and (max-width: 1199px) {
// 	.login-main-layer {
// 		width: auto;
// 	}
// }

.code-item {
  width: 170px;
  text-align: center;
  height: 130px;
}

.code-item p {
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}

// .login-main-box {
// 	width: 376px;
// 	height: 339px;
// 	padding: 32px 43px 49px;
// 	background: #ffffff;
// 	box-shadow: 0px 3px 38px 0px rgba(0, 0, 0, 0.13);
// 	border-radius: 10px;
// 	position: absolute;
// 	right: 0;
// 	/* top: 198px; */
// 	top: 50%;
// 	margin-top: -238px;
// }

.login-main-nav {
  width: 80%;
  /* display: flex;
																																																							        justify-content: space-between; */
  font-size: 18px;
  margin: 48px auto;
}

.login-main-nav a {
  color: #333333;
  padding-bottom: 5px;
  float: left;
  margin-right: 97px;
}

.login-main-nav a:last-child {
  margin-right: 0;
}

.login-main-nav a.active {
  color: #e85052;
  font-weight: 600;
  /* border-bottom: 2px solid #E85052; */
}

.login-main-pane {
  margin-top: 48px;
}

.login {
  width: 100%;
  height: 50px;
  font-size: 18px;
  margin-top: 45px;
}

.line {
  margin-top: 54px;
  background: #eeeeee;
  width: 100%;
  height: 1px;
}

.to-register:hover {
  text-decoration: underline;
}

.code-btn {
  position: absolute;
  right: 0;
  top: 0;
}

.code-btn button {
  height: 48px;
}

.msg-item {
  margin-top: 46px;
}

.account-item {
  margin-top: 49px;
}

.account-bottom {
  width: 401px;
  position: relative;
  color: #e85052;
  font-size: 16px;
  margin-bottom: 0px !important;
  margin-top: -15px;
}

.accountcode {
  display: flex;
  justify-content: space-between;
}

.code-img {
  display: block;
  width: 150px;
  height: 48px;
  position: absolute;
  right: 0;
  top: 0;
}

.to-register {
  margin-top: 12px;
  color: #e85052;
  font-size: 16px;
  text-align: right;
  display: block;
  width: 100%;
}

.account-layer {
  width: 400px;
  position: relative;
}

.account-layer .forget-password {
  position: absolute;
  left: 0;
  top: 5px;
  font-size: 16px;
  color: #e85052;
}

.account-layer .to-register {
  position: absolute;
  right: 0;
  top: 5px;
  font-size: 16px;
  color: #e85052;
  margin-top: 0;
}

.account-list-form {
  width: 260px;
  margin: 0 auto;
}

#account-list-layer .dialog-btns {
  width: 475px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.dialog-btns button {
  display: block;
  width: 179px;
  height: 50px;
  font-size: 18px;
  border-radius: 10px;
}

.customer-layer {
  position: absolute;
  right: 0;
  bottom: 90px;
}

.customer-item {
  width: 56px;
  height: 56px;
  background: #272736;
  margin-bottom: 3px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.customer-img {
  display: block;
  width: 19px;
  margin: 8px auto 0;
}

.customer-title {
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  margin-top: 4px;
  font-size: "微软雅黑";
}

.customer-item:nth-of-type(2) .customer-img {
  width: 28px;
}

.wechat-code {
  position: absolute;
  right: 64px;
  top: 0;
  width: 115px;
  height: 115px;
  background: #ffffff;
}

.wechat-code img {
  display: block;
  width: 107px;
  margin: 4px auto 0;
}
</style>
